var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssesmentBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5C3 7.84314 3 5.01472 4.75735 3.25735C6.51472 1.5 9.34314 1.5 15 1.5H21C26.6568 1.5 29.4853 1.5 31.2426 3.25735C33 5.01472 33 7.84314 33 13.5V19.5C33 25.1568 33 27.9853 31.2426 29.7426C29.4853 31.5 26.6568 31.5 21 31.5H15C9.34314 31.5 6.51472 31.5 4.75735 29.7426C3 27.9853 3 25.1568 3 19.5V13.5Z",
    fill: "url(#paint0_linear_1962_1922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7441 16.7441C10.5 16.9882 10.5 17.381 10.5 18.1667V23.1667C10.5 23.9523 10.5 24.3452 10.7441 24.5892C10.9882 24.8333 11.381 24.8333 12.1667 24.8333C12.9523 24.8333 13.3452 24.8333 13.5893 24.5892C13.8333 24.3452 13.8333 23.9523 13.8333 23.1667V18.1667C13.8333 17.381 13.8333 16.9882 13.5893 16.7441C13.3452 16.5 12.9523 16.5 12.1667 16.5C11.381 16.5 10.9882 16.5 10.7441 16.7441Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.4081 10.9081C22.1641 11.1522 22.1641 11.5451 22.1641 12.3307V23.1641C22.1641 23.9497 22.1641 24.3426 22.4081 24.5866C22.6522 24.8307 23.0451 24.8307 23.8307 24.8307C24.6164 24.8307 25.0092 24.8307 25.2533 24.5866C25.4974 24.3426 25.4974 23.9497 25.4974 23.1641V12.3307C25.4974 11.5451 25.4974 11.1522 25.2533 10.9081C25.0092 10.6641 24.6164 10.6641 23.8307 10.6641C23.0451 10.6641 22.6522 10.6641 22.4081 10.9081Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.3359 14.8307C16.3359 14.0451 16.3359 13.6522 16.58 13.4081C16.8241 13.1641 17.2169 13.1641 18.0026 13.1641C18.7883 13.1641 19.1811 13.1641 19.4252 13.4081C19.6693 13.6522 19.6693 14.0451 19.6693 14.8307V23.1641C19.6693 23.9497 19.6693 24.3426 19.4252 24.5866C19.1811 24.8307 18.7883 24.8307 18.0026 24.8307C17.2169 24.8307 16.8241 24.8307 16.58 24.5866C16.3359 24.3426 16.3359 23.9497 16.3359 23.1641V14.8307Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.709C10.1548 23.709 9.875 23.9888 9.875 24.334C9.875 24.6792 10.1548 24.959 10.5 24.959H25.5C25.8452 24.959 26.125 24.6792 26.125 24.334C26.125 23.9888 25.8452 23.709 25.5 23.709H10.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56547 13.6557C9.25317 13.8027 9.11919 14.1751 9.26621 14.4873C9.41322 14.7996 9.78559 14.9336 10.0979 14.7866L23.6692 8.39764C23.9815 8.25062 24.1155 7.87825 23.9685 7.56596C23.8215 7.25367 23.4491 7.11968 23.1368 7.2667L9.56547 13.6557Z",
    fill: "#A0A6B6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1962_1922",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssesmentBlueIcon);
export default __webpack_public_path__ + "static/media/assesment_blue_icon.518db63bd3259941632afd36df3df45b.svg";
export { ForwardRef as ReactComponent };